/* eslint-disable no-unused-vars */
import React from 'react'
import {
  strCol,
  dateCol,
  numCol,
  dollarCol,
  dateTimeCol,
  intCol,
} from '@integec/grid-tools/lib/cols'
import { YNBooleanTypes, unitIdHeader } from 'core/HeaderColTypeProps'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import moment from 'moment'
import numeral from 'numeral'
import R from 'ramda'
import { DATE_TIME_FORMAT_UI } from 'enum'
import {
  generateGridHeaderForMetaInfo,
  generateMetaInfoMap,
  getColorFromColorInfoMap,
  getColorInfoMapFromList,
  getFootersFromMap,
  getHeadersFromMap,
} from 'report-dashboard/utils'
import { getWorkbook } from 'core/component/xlsx-utils'
import { fillMetaData } from 'workers/file-worker'
import { ValueType } from 'exceljs'

export const OaEventIoHeaders = [
  strCol({ ident: 'unitname', display: 'Unitname', isFiltered: true }),
  strCol({ ident: 'utility', display: 'Utility', isFiltered: true }),
  strCol({ ident: 'unit', display: 'Unit', isFiltered: true }),
  numCol({ ident: 'year', display: 'Year', isFiltered: true }),
  numCol({ ident: 'eventnum', display: 'Eventnum', isFiltered: true }),
  strCol({ ident: 'eventtype', display: 'Eventtype', isFiltered: true }),
  dateCol({ ident: 'eventstart', display: 'Eventstart', isFiltered: true }),
  dateCol({
    ident: 'eventstartGmt',
    display: 'EventstartGmt',
    isFiltered: true,
  }),
  dateCol({ ident: 'eventend', display: 'Eventend', isFiltered: true }),
  dateCol({ ident: 'eventendGmt', display: 'EventendGmt', isFiltered: true }),
  dateCol({
    ident: 'eventendOriginal',
    display: 'EventendOriginal',
    isFiltered: true,
  }),
  numCol({ ident: 'availcap', display: 'Availcap', isFiltered: true }),
  numCol({ ident: 'foh', display: 'Foh', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'Efdh', isFiltered: true }),
  numCol({ ident: 'efdhrs', display: 'Efdhrs', isFiltered: true }),
  numCol({ ident: 'servSyncPump', display: 'ServSyncPump', isFiltered: true }),
  numCol({ ident: 'lostEhrs', display: 'LostEhrs', isFiltered: true }),
  numCol({ ident: 'lostOppMwh', display: 'LostOppMwh', isFiltered: true }),
  numCol({
    ident: 'lostOppRevenue',
    display: 'LostOppRevenue',
    isFiltered: true,
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'UnavailMwCost',
    isFiltered: true,
  }),
  numCol({
    ident: 'lostOppMargin',
    display: 'LostOppMargin',
    isFiltered: true,
  }),
  intCol({ ident: 'causecode', display: 'Causecode', isFiltered: true }),
  strCol({ ident: 'causecodeMod', display: 'CausecodeMod', isFiltered: true }),
  strCol({ ident: 'causeDescrip', display: 'CauseDescrip', isFiltered: true }),
  strCol({ ident: 'description', display: 'Description', isFiltered: true }),
  numCol({ ident: 'netdepcap', display: 'Netdepcap', isFiltered: true }),
  strCol({
    ident: 'scenarioEvent',
    display: 'ScenarioEvent',
    isFiltered: true,
  }),
  strCol({ ident: 'ampCode', display: 'AmpCode', isFiltered: true }),
  strCol({ ident: 'failCode', display: 'FailCode', isFiltered: true }),
  strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  strCol({ ident: 'action', display: 'Action', isKey: true }),
]

export const OaTmpMaDisplayHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  strCol({ ident: 'displayName', display: 'DisplayName', isFiltered: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  numCol({ ident: 'hour', display: 'Hour', isKey: true }),
  numCol({ ident: 'rtLmp', display: 'RtLmp', isFiltered: true }),
  numCol({ ident: 'daLmp', display: 'DaLmp', isFiltered: true }),
  numCol({ ident: 'daAwardMw', display: 'DaAwardMw', isFiltered: true }),
  numCol({ ident: 'forecastLmp', display: 'ForecastLmp', isFiltered: true }),
  numCol({ ident: 'ecominrate', display: 'Ecominrate', isFiltered: true }),
  numCol({ ident: 'ecomaxrate', display: 'Ecomaxrate', isFiltered: true }),
  numCol({ ident: 'genMw', display: 'GenMw', isFiltered: true }),
  numCol({ ident: 'targetMw', display: 'TargetMw', isFiltered: true }),
  numCol({ ident: 'dispatchMw', display: 'DispatchMw', isFiltered: true }),
  numCol({ ident: 'availMw', display: 'AvailMw', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'LostMwh', isFiltered: true }),
  numCol({
    ident: 'lostRevDollar',
    display: 'LostRevDollar',
    isFiltered: true,
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'UnavailMwCost',
    isFiltered: true,
  }),
  strCol({ ident: 'eventtype', display: 'Eventtype', isFiltered: true }),
  strCol({ ident: 'eventnumber', display: 'Eventnumber', isFiltered: true }),
  numCol({ ident: 'eventlmp', display: 'Eventlmp', isFiltered: true }),
  strCol({ ident: 'demandStatus', display: 'DemandStatus', isFiltered: true }),
  numCol({ ident: 'noloadCost', display: 'NoloadCost', isFiltered: true }),
  dateCol({
    ident: 'laststartdate',
    display: 'Laststartdate',
    isFiltered: true,
  }),
  strCol({
    ident: 'startcostType',
    display: 'StartcostType',
    isFiltered: true,
  }),
  numCol({ ident: 'startcost', display: 'Startcost', isFiltered: true }),
  numCol({
    ident: 'startcostShare',
    display: 'StartcostShare',
    isFiltered: true,
  }),
  numCol({ ident: 'totalGencost', display: 'TotalGencost', isFiltered: true }),
  numCol({ ident: 'cStartcost', display: 'CStartcost', isFiltered: true }),
  numCol({
    ident: 'cStartcostShare',
    display: 'CStartcostShare',
    isFiltered: true,
  }),
  numCol({
    ident: 'cTotalGencost',
    display: 'CTotalGencost',
    isFiltered: true,
  }),
  numCol({ ident: 'totalMargin', display: 'TotalMargin', isFiltered: true }),
  strCol({ ident: 'pfuelCode', display: 'PfuelCode', isFiltered: true }),
  strCol({
    ident: 'startfuelCode',
    display: 'StartfuelCode',
    isFiltered: true,
  }),
  numCol({ ident: 'netdepcap', display: 'Netdepcap', isFiltered: true }),
  numCol({ ident: 'ecoMax', display: 'EcoMax', isFiltered: true }),
  numCol({ ident: 'ecoMin', display: 'EcoMin', isFiltered: true }),
  numCol({ ident: 'regCredit', display: 'RegCredit', isFiltered: true }),
  numCol({ ident: 'regMw', display: 'RegMw', isFiltered: true }),
  numCol({ ident: 'regMcp', display: 'RegMcp', isFiltered: true }),
  numCol({
    ident: 'spinResvCredit',
    display: 'SpinResvCredit',
    isFiltered: true,
  }),
  numCol({ ident: 'spinResvMw', display: 'SpinResvMw', isFiltered: true }),
  numCol({ ident: 'spinResvMcp', display: 'SpinResvMcp', isFiltered: true }),
  strCol({ ident: 'peak', display: 'Peak', isFiltered: true }),
  numCol({
    ident: 'opReserveDpmw',
    display: 'OpReserveDpmw',
    isFiltered: true,
  }),
  numCol({ ident: 'opReservePct', display: 'OpReservePct', isFiltered: true }),
  strCol({ ident: 'explanation', display: 'Explanation', isFiltered: true }),
  numCol({ ident: 'daRevenue', display: 'DaRevenue', isFiltered: true }),
  numCol({ ident: 'rtRevenue', display: 'RtRevenue', isFiltered: true }),
  numCol({
    ident: 'targetRevenue',
    display: 'TargetRevenue',
    isFiltered: true,
  }),
  numCol({
    ident: 'actualRevenue',
    display: 'ActualRevenue',
    isFiltered: true,
  }),
  numCol({ ident: 'totalCost', display: 'TotalCost', isFiltered: true }),
  numCol({ ident: 'actualMargin', display: 'ActualMargin', isFiltered: true }),
  numCol({ ident: 'lostMargin', display: 'LostMargin', isFiltered: true }),
  numCol({ ident: 'otherCredit1', display: 'OtherCredit1', isFiltered: true }),
  numCol({ ident: 'otherCredit2', display: 'OtherCredit2', isFiltered: true }),
  numCol({
    ident: 'otherQuantity1',
    display: 'OtherQuantity1',
    isFiltered: true,
  }),
  numCol({
    ident: 'otherQuantity2',
    display: 'OtherQuantity2',
    isFiltered: true,
  }),
  numCol({ ident: 'otherCost1', display: 'OtherCost1', isFiltered: true }),
  numCol({ ident: 'otherCost2', display: 'OtherCost2', isFiltered: true }),
  numCol({ ident: 'ownership', display: 'Ownership', isFiltered: true }),
  strCol({ ident: 'causecode', display: 'Causecode', isFiltered: true }),
]

const actualEventWidth = 100 + 100 + 150 + 150 + 600 + 400 + 100
export const eventDescWidth = totalWidth =>
  totalWidth - actualEventWidth < 400 ? 400 : totalWidth - actualEventWidth

export const OaEventIoHeadersCPS = totalWidth => [
  // strCol({ ident: 'unitname', display: 'Unitname', isFiltered: true }),
  // strCol({ ident: 'utility', display: 'Utility', isFiltered: true }),
  // strCol({ ident: 'unit', display: 'Unit', isFiltered: true }),
  // numCol({ ident: 'year', display: 'Year', isFiltered: true }),
  intCol({ ident: 'eventnum', display: 'Event #', isFiltered: true }),
  strCol({
    ident: 'scenarioEvent',
    display: 'Manually Added',
    // ...toSelectionColProps(YNBooleanTypes),
    dataGetter: ({ rowData }) =>
      rowData.scenarioEvent === 'Y' || rowData.scenarioEvent === 'y'
        ? 'Yes'
        : 'No',
  }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    isFiltered: true,
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  // dateTimeCol({
  //   ident: 'eventstartGmt',
  //   display: 'EventstartGmt',
  //   isFiltered: true,
  //   width: 150,
  // }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    isFiltered: true,
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  numCol({
    ident: 'duration',
    display: 'Duration',
  }),
  // dateCol({ ident: 'eventendGmt', display: 'EventendGmt', isFiltered: true }),
  // dateCol({
  //   ident: 'eventendOriginal',
  //   display: 'EventendOriginal',
  //   isFiltered: true,
  // }),
  numCol({
    ident: 'availcap',
    display: 'Avail Cap',
    isFiltered: true,
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'lostOppMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '0,0.00',
  }),
  dollarCol({
    ident: 'lostOppRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'lostOppMargin',
    display: 'Lost Margin',
    isFiltered: true,
  }),
  numCol({ ident: 'lostEhrs', display: 'Lost Eqv Hrs', isFiltered: true }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isFiltered: true,
    displayFormat: '0',
  }),
  strCol({
    ident: 'causeDescrip',
    display: 'Cause Description',
    isFiltered: true,
    width: 400,
    ellipsis: true,
    alignment: 'left',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isFiltered: true,
    width: eventDescWidth(totalWidth),
    ellipsis: true,
    alignment: 'left',
  }),
  // numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  // numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  // numCol({ ident: 'efdhrs', display: 'EFDHRS', isFiltered: true }),
  // numCol({
  //   ident: 'servSyncPump',
  //   display: 'Serv Sync Pump',
  //   isFiltered: true,
  // }),
  // strCol({ ident: 'causecodeMod', display: 'Causecode Mod', isFiltered: true }),
  //   numCol({
  //     ident: 'unavailMwCost',
  //     display: 'UnavailMwCost',
  //     isFiltered: true,
  //   }),
  //  numCol({ ident: 'netdepcap', display: 'Netdepcap', isFiltered: true }),
  //   strCol({
  //     ident: 'scenarioEvent',
  //     display: 'ScenarioEvent',
  //     isFiltered: true,
  //   }),
  //   strCol({ ident: 'ampCode', display: 'AmpCode', isFiltered: true }),
  //   strCol({ ident: 'failCode', display: 'FailCode', isFiltered: true }),
  //   strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  //  strCol({ ident: 'action', display: 'Action', isKey: true }),
]

export const OaTmpMaDisplayExportHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  strCol({ ident: 'displayName', display: 'Display Name', isFiltered: true }),
  dateCol({ ident: 'transdate', display: 'Date', isKey: true }),
  intCol({ ident: 'hour', display: 'Hour', isKey: true }),
  dollarCol({ ident: 'rtLmp', display: 'RT Lmp', isFiltered: true }),
  dollarCol({ ident: 'daLmp', display: 'DA Lmp', isFiltered: true }),
  numCol({ ident: 'daAwardMw', display: 'Da Award MW', isFiltered: true }),
  numCol({ ident: 'ecominrate', display: 'Eco Min Rate', isFiltered: true }),
  numCol({ ident: 'ecomaxrate', display: 'Eco max Rate', isFiltered: true }),
  numCol({ ident: 'genMw', display: 'Gen MWH', isFiltered: true }),
  dollarCol({
    ident: 'daRevenue',
    display: 'DA Revenue',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'rtRevenue',
    display: 'RT Revenue',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({ ident: 'regCredit', display: 'Reg Credit', isFiltered: true }),
  numCol({ ident: 'otherCredit1', display: 'Make-Whole', isFiltered: true }),
  numCol({
    ident: 'otherCredit2',
    display: 'LMO Adjustment',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'totalGencost',
    display: 'Generation Cost',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'startcostShare',
    display: 'Start Cost Share',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    width: 120,
  }),
  numCol({ ident: 'actualMargin', display: 'Energy Margin', isFiltered: true }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  strCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
  numCol({ ident: 'targetMw', display: 'Target MW', isFiltered: true }),
  dollarCol({
    ident: 'targetRevenue',
    display: 'Target Revenue',
    isFiltered: true,
    width: 120,
  }),
  numCol({ ident: 'availMw', display: 'Avail MW', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'Lost MWH', isFiltered: true }),
  dollarCol({
    ident: 'lostRevDollar',
    display: 'Lost Revenue',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'unavailMwCost',
    display: 'Cost Of Lost  MWH',
    isFiltered: true,
  }),
  dollarCol({ ident: 'lostMargin', display: 'Lost Margin', isFiltered: true }),
  strCol({ ident: 'explanation', display: 'Explanation', isFiltered: true }),
  strCol({
    ident: 'startfuelCode',
    display: 'Start Fuel',
    isFiltered: true,
  }),
  strCol({ ident: 'pfuelCode', display: 'Gen Fuel', isFiltered: true }),
  dateCol({
    ident: 'laststartdate',
    display: 'Last Start Date',
    isFiltered: true,
  }),
  strCol({
    ident: 'startcostType',
    display: 'Last Start Type',
    isFiltered: true,
  }),
  numCol({ ident: 'startcost', display: 'Last Start Cost', isFiltered: true }),
  numCol({ ident: 'netdepcap', display: 'Net Dep Cap', isFiltered: true }),
  numCol({ ident: 'ecoMax', display: 'Eco Max', isFiltered: true }),
  numCol({ ident: 'ecoMin', display: 'Eco Min', isFiltered: true }),

  /* below is not used for export 
  numCol({ ident: 'dispatchMw', display: 'DispatchMw', isFiltered: true }),
  strCol({ ident: 'eventnumber', display: 'Eventnumber', isFiltered: true }),
  numCol({ ident: 'eventlmp', display: 'Eventlmp', isFiltered: true }),
  strCol({ ident: 'demandStatus', display: 'DemandStatus', isFiltered: true }),
  numCol({ ident: 'noloadCost', display: 'NoloadCost', isFiltered: true }),
  numCol({ ident: 'cStartcost', display: 'CStartcost', isFiltered: true }),
  numCol({
    ident: 'cStartcostShare',
    display: 'CStartcostShare',
    isFiltered: true,
  }),
  numCol({
    ident: 'cTotalGencost',
    display: 'CTotalGencost',
    isFiltered: true,
  }),
  numCol({ ident: 'totalMargin', display: 'TotalMargin', isFiltered: true }),
  numCol({ ident: 'regMw', display: 'RegMw', isFiltered: true }),
  numCol({ ident: 'regMcp', display: 'RegMcp', isFiltered: true }),
  numCol({
    ident: 'spinResvCredit',
    display: 'SpinResvCredit',
    isFiltered: true,
  }),
  numCol({ ident: 'spinResvMw', display: 'SpinResvMw', isFiltered: true }),
  numCol({ ident: 'spinResvMcp', display: 'SpinResvMcp', isFiltered: true }),
  strCol({ ident: 'peak', display: 'Peak', isFiltered: true }),
  numCol({
    ident: 'opReserveDpmw',
    display: 'OpReserveDpmw',
    isFiltered: true,
  }),
  numCol({ ident: 'opReservePct', display: 'OpReservePct', isFiltered: true }),
  numCol({ ident: 'otherCredit1', display: 'OtherCredit1', isFiltered: true }),
  numCol({ ident: 'otherCredit2', display: 'OtherCredit2', isFiltered: true }),
  numCol({
    ident: 'otherQuantity1',
    display: 'OtherQuantity1',
    isFiltered: true,
  }),
  numCol({
    ident: 'otherQuantity2',
    display: 'OtherQuantity2',
    isFiltered: true,
  }),
  numCol({ ident: 'otherCost1', display: 'OtherCost1', isFiltered: true }),
  numCol({ ident: 'otherCost2', display: 'OtherCost2', isFiltered: true }),
  numCol({ ident: 'ownership', display: 'Ownership', isFiltered: true }), */
]

export const PSEOaTmpMaDisplayExportHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  strCol({ ident: 'displayName', display: 'Display Name', isFiltered: true }),
  dateCol({ ident: 'transdate', display: 'Date', isKey: true }),
  intCol({ ident: 'hour', display: 'Hour', isKey: true }),
  dollarCol({ ident: 'rtLmp', display: 'LMP/Lambda', isFiltered: true }),
  // dollarCol({ ident: 'daLmp', display: 'DA Lmp', isFiltered: true }),
  // numCol({ ident: 'daAwardMw', display: 'Da Award MW', isFiltered: true }),
  numCol({ ident: 'ecominrate', display: 'Eco Min Rate', isFiltered: true }),
  numCol({ ident: 'ecomaxrate', display: 'Eco max Rate', isFiltered: true }),
  numCol({ ident: 'genMw', display: 'Gen MWh', isFiltered: true }),
  // dollarCol({
  //   ident: 'daRevenue',
  //   display: 'DA Revenue',
  //   isFiltered: true,
  //   width: 120,
  // }),
  // dollarCol({
  //   ident: 'rtRevenue',
  //   display: 'RT Revenue',
  //   isFiltered: true,
  //   width: 120,
  // }),
  dollarCol({
    ident: 'regCredit',
    display: 'Spin Res. Credit',
    isFiltered: true,
  }),
  // numCol({ ident: 'otherCredit1', display: 'Make-Whole', isFiltered: true }),
  // numCol({
  //   ident: 'otherCredit2',
  //   display: 'LMO Adjustment',
  //   isFiltered: true,
  // }),
  dollarCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'totalGencost',
    display: 'Generation Cost',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'startcostShare',
    display: 'Start Cost Share',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    width: 120,
  }),
  numCol({ ident: 'actualMargin', display: 'Actual Margin', isFiltered: true }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  // strCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
  numCol({ ident: 'targetMw', display: 'Target MW', isFiltered: true }),
  dollarCol({
    ident: 'targetRevenue',
    display: 'Target Revenue',
    isFiltered: true,
    width: 120,
  }),
  numCol({ ident: 'availMw', display: 'Avail MW', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'Lost MWh', isFiltered: true }),
  dollarCol({
    ident: 'lostRevDollar',
    display: 'Lost Opp Revenue',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'unavailMwCost',
    display: 'Cost Of Lost  MWh',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'lostMargin',
    display: 'Lost Opp Margin',
    isFiltered: true,
  }),
  strCol({ ident: 'explanation', display: 'Explanation', isFiltered: true }),
  strCol({
    ident: 'startfuelCode',
    display: 'Start Fuel',
    isFiltered: true,
  }),
  strCol({ ident: 'pfuelCode', display: 'Gen Fuel', isFiltered: true }),
  dateCol({
    ident: 'laststartdate',
    display: 'Last Start Date',
    isFiltered: true,
  }),
  strCol({
    ident: 'startcostType',
    display: 'Last Start Type',
    isFiltered: true,
  }),
  numCol({ ident: 'startcost', display: 'Last Start Cost', isFiltered: true }),
  numCol({ ident: 'netdepcap', display: 'Net Dep Cap', isFiltered: true }),
  numCol({ ident: 'ecoMax', display: 'Eco Max', isFiltered: true }),
  numCol({ ident: 'ecoMin', display: 'Eco Min', isFiltered: true }),

  /* below is not used for export 
  numCol({ ident: 'dispatchMw', display: 'DispatchMw', isFiltered: true }),
  strCol({ ident: 'eventnumber', display: 'Eventnumber', isFiltered: true }),
  numCol({ ident: 'eventlmp', display: 'Eventlmp', isFiltered: true }),
  strCol({ ident: 'demandStatus', display: 'DemandStatus', isFiltered: true }),
  numCol({ ident: 'noloadCost', display: 'NoloadCost', isFiltered: true }),
  numCol({ ident: 'cStartcost', display: 'CStartcost', isFiltered: true }),
  numCol({
    ident: 'cStartcostShare',
    display: 'CStartcostShare',
    isFiltered: true,
  }),
  numCol({
    ident: 'cTotalGencost',
    display: 'CTotalGencost',
    isFiltered: true,
  }),
  numCol({ ident: 'totalMargin', display: 'TotalMargin', isFiltered: true }),
  numCol({ ident: 'regMw', display: 'RegMw', isFiltered: true }),
  numCol({ ident: 'regMcp', display: 'RegMcp', isFiltered: true }),
  numCol({
    ident: 'spinResvCredit',
    display: 'SpinResvCredit',
    isFiltered: true,
  }),
  numCol({ ident: 'spinResvMw', display: 'SpinResvMw', isFiltered: true }),
  numCol({ ident: 'spinResvMcp', display: 'SpinResvMcp', isFiltered: true }),
  strCol({ ident: 'peak', display: 'Peak', isFiltered: true }),
  numCol({
    ident: 'opReserveDpmw',
    display: 'OpReserveDpmw',
    isFiltered: true,
  }),
  numCol({ ident: 'opReservePct', display: 'OpReservePct', isFiltered: true }),
  numCol({ ident: 'otherCredit1', display: 'OtherCredit1', isFiltered: true }),
  numCol({ ident: 'otherCredit2', display: 'OtherCredit2', isFiltered: true }),
  numCol({
    ident: 'otherQuantity1',
    display: 'OtherQuantity1',
    isFiltered: true,
  }),
  numCol({
    ident: 'otherQuantity2',
    display: 'OtherQuantity2',
    isFiltered: true,
  }),
  numCol({ ident: 'otherCost1', display: 'OtherCost1', isFiltered: true }),
  numCol({ ident: 'otherCost2', display: 'OtherCost2', isFiltered: true }),
  numCol({ ident: 'ownership', display: 'Ownership', isFiltered: true }), */
]
export const SRPOaTmpMaDisplayExportHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  strCol({ ident: 'displayName', display: 'Display Name', isFiltered: true }),
  dateCol({ ident: 'transdate', display: 'Date', isKey: true }),
  intCol({ ident: 'hour', display: 'Hour', isKey: true }),
  dollarCol({ ident: 'rtLmp', display: 'LMP/Lambda', isFiltered: true }),
  numCol({ ident: 'ecominrate', display: 'Eco Min Rate', isFiltered: true }),
  numCol({ ident: 'ecomaxrate', display: 'Eco max Rate', isFiltered: true }),
  numCol({ ident: 'genMw', display: 'Gen MWh', isFiltered: true }),
  dollarCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'totalGencost',
    display: 'Generation Cost',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'startcostShare',
    display: 'Start Cost Share',
    isFiltered: true,
  }),
  dollarCol({ ident: 'totalCost', display: 'Total Cost', isFiltered: true }),
  numCol({ ident: 'actualMargin', display: 'Actual Margin', isFiltered: true }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  numCol({ ident: 'targetMw', display: 'Target MW', isFiltered: true }),
  dollarCol({
    ident: 'targetRevenue',
    display: 'Target Revenue',
    isFiltered: true,
  }),
  numCol({ ident: 'availMw', display: 'Avail MW', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'Lost MWH', isFiltered: true }),
  dollarCol({
    ident: 'lostRevDollar',
    display: 'Lost Opp Revenue',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'unavailMwCost',
    display: 'Cost Of Lost  MWH',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'lostMargin',
    display: 'Lost Opp Margin',
    isFiltered: true,
  }),
  strCol({ ident: 'explanation', display: 'Explanation', isFiltered: true }),
  strCol({
    ident: 'startfuelCode',
    display: 'Start Fuel',
    isFiltered: true,
  }),
  strCol({ ident: 'pfuelCode', display: 'Gen Fuel', isFiltered: true }),
  dateCol({
    ident: 'laststartdate',
    display: 'Last Start Date',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'startcostType',
    display: 'Last Start Type',
    isFiltered: true,
  }),
  numCol({ ident: 'startcost', display: 'Last Start Cost', isFiltered: true }),
  numCol({ ident: 'netdepcap', display: 'Net Dep Cap', isFiltered: true }),
  numCol({ ident: 'ecoMax', display: 'Eco Max', isFiltered: true }),
  numCol({ ident: 'ecoMin', display: 'Eco Min', isFiltered: true }),

  // dollarCocsWDEQl({ ident: 'daLmp', display: 'DA Lmp', isFiltered: true }),
  // numCol({ ident: 'daAwardMw', display: 'Da Award MW', isFiltered: true }),
  // dollarCol({ ident: 'daRevenue', display: 'DA Revenue', isFiltered: true }),
  // dollarCol({ ident: 'rtRevenue', display: 'RT Revenue', isFiltered: true }),
  // dollarCol({ ident: 'regCredit', display: 'Reg Credit', isFiltered: true }),
  // numCol({ ident: 'otherCredit1', display: 'Make-Whole', isFiltered: true }),
  // numCol({
  //   ident: 'otherCredit2',
  //   display: 'LMO Adjustment',
  //   isFiltered: true,
  // }),
  // strCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
]

export const OaTmpMaTotalsHeaders = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'actualMargin',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Potential Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Unavail MW Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),

  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
  // numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  // numCol({ ident: 'numval2', display: 'Numval2', isFiltered: true }),
  // numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  // numCol({ ident: 'numval4', display: 'Numval4', isFiltered: true }),
  // numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  // numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersPSE = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'actualMargin',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Target Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Unavail MW Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersCLECO = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  // numCol({
  //   ident: 'totalCost',
  //   display: 'Total Cost',
  //   isFiltered: true,
  //   displayFormat: '000,000.00',
  // }),
  numCol({
    ident: 'actualMargin',
    display: 'Energy Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval4',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Potential Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Cost of Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval1',
    display: 'Planned Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval2',
    display: 'Market Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersCPS = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  // numCol({
  //   ident: 'totalCost',
  //   display: 'Total Cost',
  //   isFiltered: true,
  //   displayFormat: '000,000.00',
  // }),
  numCol({
    ident: 'actualMargin',
    display: 'Energy Margin',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'numval4',
    display: 'Actual Margin',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Potential Revenue',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Unavail MW Cost',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),

  numCol({
    ident: 'numval1',
    display: 'Planned Lost Margin',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),

  numCol({
    ident: 'numval2',
    display: 'Market Lost Margin',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    // displayFormat: '000,000.00',
    displayFormat: '0,0.00',
  }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
  // numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  // numCol({ ident: 'numval2', display: 'Numval2', isFiltered: true }),
  // numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  // numCol({ ident: 'numval4', display: 'Numval4', isFiltered: true }),
  // numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  // numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersDOM = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval4',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Potential Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Cost of Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval1',
    display: 'Planned Lost Margin',
    isFiltered: true,
  }),
  numCol({ ident: 'numval2', display: 'Market Lost Margin', isFiltered: true }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
  // numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  // numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  // numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  // numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersAPS = [
  numCol({ ident: 'numval1', display: 'CCA %', isFiltered: true }),
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'actualMargin',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Target Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Unavail MW Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  // numCol({ ident: 'numval2', display: 'Market Lost Margin', isFiltered: true }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EUOR', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'Num. FO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
  // numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  // numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  // numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  // numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersWEE = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval4',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Potential Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Cost of Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'numval2', display: 'Market Lost Margin', isFiltered: true }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
  // numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  // numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  // numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  // numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
]

export const OaTmpMaTotalsHeadersNRG = [
  numCol({ ident: 'caPercent', display: 'CA %', isFiltered: true }),
  numCol({
    ident: 'actualRevenue',
    display: 'Actual Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'actualMargin',
    display: 'Energy Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval3',
    display: 'VOM',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval4',
    display: 'Actual Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'targetRevenue',
    display: 'Potential Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMwh',
    display: 'Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostRevenue',
    display: 'Lost Revenue',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'unavailMwCost',
    display: 'Cost of Lost MWH',
    isFiltered: true,
    displayFormat: '000,000.00',
    width: 150,
  }),
  numCol({
    ident: 'lostMargin',
    display: 'Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval1',
    display: 'Planned Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval2',
    display: 'Market Lost Margin',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'numval5',
    display: 'LOF',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({
    ident: 'lostEhrs',
    display: 'Lost Eqv Hrs',
    isFiltered: true,
    displayFormat: '000,000.00',
  }),
  numCol({ ident: 'euof', display: 'EUOF', isFiltered: true }),
  numCol({ ident: 'euor', display: 'EURO', isFiltered: true }),
  numCol({ ident: 'efor', display: 'EFOR', isFiltered: true }),
  numCol({ ident: 'eford', display: 'EFORD', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'FOR', isFiltered: true }),
  numCol({ ident: 'epor', display: 'EPOR', isFiltered: true }),
  numCol({ ident: 'emor', display: 'EMOR', isFiltered: true }),
  numCol({ ident: 'sf', display: 'SF', isFiltered: true }),
  numCol({ ident: 'af', display: 'AF', isFiltered: true }),
  numCol({ ident: 'uf', display: 'UF', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'EAF', isFiltered: true }),
  numCol({ ident: 'euf', display: 'EUF', isFiltered: true }),
  numCol({ ident: 'udf', display: 'UDF', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'SEDF', isFiltered: true }),
  numCol({ ident: 'pof', display: 'POF', isFiltered: true }),
  numCol({ ident: 'uof', display: 'UOF', isFiltered: true }),
  numCol({ ident: 'fof', display: 'FOF', isFiltered: true }),
  numCol({ ident: 'mof', display: 'MOF', isFiltered: true }),
  numCol({ ident: 'sof', display: 'SOF', isFiltered: true }),
  numCol({ ident: 'epof', display: 'EPOF', isFiltered: true }),
  numCol({ ident: 'efof', display: 'EFOF', isFiltered: true }),
  numCol({ ident: 'emof', display: 'EMOF', isFiltered: true }),
  numCol({ ident: 'esof', display: 'ESOF', isFiltered: true }),
  numCol({ ident: 'art', display: 'ART', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cycling Rate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'SR', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'MSTPO', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'MSTUO', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'MSTFO', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'MSTMO', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'MPOD', isFiltered: true }),
  numCol({ ident: 'muod', display: 'MUOD', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'MFOD', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'MMOD', isFiltered: true }),
  numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'NUMFO', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Att. Start', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actual Start', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Avail. Hrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Res. Hour', isFiltered: true }),
  // numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  // numCol({ ident: 'numval2', display: 'Numval2', isFiltered: true }),
  // numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  // numCol({ ident: 'numval4', display: 'Numval4', isFiltered: true }),
  // numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  // numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
]

const OaTmpMaTotalsHeadersOriginal = [
  numCol({ ident: 'actualMargin', display: 'ActualMargin', isFiltered: true }),
  numCol({ ident: 'lostRevenue', display: 'LostRevenue', isFiltered: true }),
  numCol({
    ident: 'unavailMwCost',
    display: 'UnavailMwCost',
    isFiltered: true,
  }),
  numCol({ ident: 'lostMargin', display: 'LostMargin', isFiltered: true }),
  numCol({ ident: 'sf', display: 'Sf', isFiltered: true }),
  numCol({ ident: 'af', display: 'Af', isFiltered: true }),
  numCol({ ident: 'uf', display: 'Uf', isFiltered: true }),
  numCol({ ident: 'eaf', display: 'Eaf', isFiltered: true }),
  numCol({ ident: 'euf', display: 'Euf', isFiltered: true }),
  numCol({ ident: 'udf', display: 'Udf', isFiltered: true }),
  numCol({ ident: 'sedf', display: 'Sedf', isFiltered: true }),
  numCol({ ident: 'pof', display: 'Pof', isFiltered: true }),
  numCol({ ident: 'uof', display: 'Uof', isFiltered: true }),
  numCol({ ident: 'fof', display: 'Fof', isFiltered: true }),
  numCol({ ident: 'mof', display: 'Mof', isFiltered: true }),
  numCol({ ident: 'sof', display: 'Sof', isFiltered: true }),
  numCol({ ident: 'epof', display: 'Epof', isFiltered: true }),
  numCol({ ident: 'euof', display: 'Euof', isFiltered: true }),
  numCol({ ident: 'efof', display: 'Efof', isFiltered: true }),
  numCol({ ident: 'emof', display: 'Emof', isFiltered: true }),
  numCol({ ident: 'esof', display: 'Esof', isFiltered: true }),
  numCol({ ident: 'forcedor', display: 'Forcedor', isFiltered: true }),
  numCol({ ident: 'epor', display: 'Epor', isFiltered: true }),
  numCol({ ident: 'euor', display: 'Euor', isFiltered: true }),
  numCol({ ident: 'efor', display: 'Efor', isFiltered: true }),
  numCol({ ident: 'eford', display: 'Eford', isFiltered: true }),
  numCol({ ident: 'emor', display: 'Emor', isFiltered: true }),
  numCol({ ident: 'art', display: 'Art', isFiltered: true }),
  numCol({ ident: 'cyclingrate', display: 'Cyclingrate', isFiltered: true }),
  numCol({ ident: 'sr', display: 'Sr', isFiltered: true }),
  numCol({ ident: 'mstpo', display: 'Mstpo', isFiltered: true }),
  numCol({ ident: 'mstuo', display: 'Mstuo', isFiltered: true }),
  numCol({ ident: 'mstfo', display: 'Mstfo', isFiltered: true }),
  numCol({ ident: 'mstmo', display: 'Mstmo', isFiltered: true }),
  numCol({ ident: 'mpod', display: 'Mpod', isFiltered: true }),
  numCol({ ident: 'muod', display: 'Muod', isFiltered: true }),
  numCol({ ident: 'mfod', display: 'Mfod', isFiltered: true }),
  numCol({ ident: 'mmod', display: 'Mmod', isFiltered: true }),
  numCol({ ident: 'foh', display: 'Foh', isFiltered: true }),
  numCol({ ident: 'efdh', display: 'Efdh', isFiltered: true }),
  numCol({ ident: 'numfo', display: 'Numfo', isFiltered: true }),
  numCol({ ident: 'attstart', display: 'Attstart', isFiltered: true }),
  numCol({ ident: 'actualstart', display: 'Actualstart', isFiltered: true }),
  numCol({ ident: 'availhrs', display: 'Availhrs', isFiltered: true }),
  numCol({ ident: 'reshour', display: 'Reshour', isFiltered: true }),
  numCol({ ident: 'numval1', display: 'Numval1', isFiltered: true }),
  numCol({ ident: 'numval2', display: 'Numval2', isFiltered: true }),
  numCol({ ident: 'numval3', display: 'Numval3', isFiltered: true }),
  numCol({ ident: 'numval4', display: 'Numval4', isFiltered: true }),
  numCol({ ident: 'numval5', display: 'Numval5', isFiltered: true }),
  numCol({ ident: 'numval6', display: 'Numval6', isFiltered: true }),
  numCol({ ident: 'caPercent', display: 'CaPercent', isFiltered: true }),
  numCol({ ident: 'lostEhrs', display: 'LostEhrs', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'LostMwh', isFiltered: true }),
  numCol({
    ident: 'targetRevenue',
    display: 'TargetRevenue',
    isFiltered: true,
  }),
  numCol({
    ident: 'actualRevenue',
    display: 'ActualRevenue',
    isFiltered: true,
  }),
  numCol({ ident: 'totalCost', display: 'TotalCost', isFiltered: true }),
]

const OaPnodeZoneHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'effectivedate', display: 'Effectivedate', isKey: true }),
  strCol({ ident: 'pnodeid', display: 'Pnodeid', isKey: true }),
  strCol({ ident: 'emktid', display: 'Emktid', isFiltered: true }),
  strCol({ ident: 'rollupEmktid', display: 'RollupEmktid', isFiltered: true }),
]

const OaMaMonthlyHeaders = [
  numCol({ ident: 'lostMargin', display: 'LostMargin', isFiltered: true }),
  strCol({ ident: 'unitid', display: 'Unitid', isKey: true }),
  numCol({ ident: 'year', display: 'Year', isKey: true }),
  numCol({ ident: 'month', display: 'Month', isKey: true }),
  numCol({ ident: 'caPercent', display: 'CaPercent', isFiltered: true }),
  numCol({ ident: 'lostEhrs', display: 'LostEhrs', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'LostMwh', isFiltered: true }),
  numCol({
    ident: 'targetRevenue',
    display: 'TargetRevenue',
    isFiltered: true,
  }),
  numCol({
    ident: 'actualRevenue',
    display: 'ActualRevenue',
    isFiltered: true,
  }),
  numCol({ ident: 'totalCost', display: 'TotalCost', isFiltered: true }),
  numCol({ ident: 'actualMargin', display: 'ActualMargin', isFiltered: true }),
  numCol({ ident: 'lostRevenue', display: 'LostRevenue', isFiltered: true }),
  numCol({
    ident: 'unavailMwCost',
    display: 'UnavailMwCost',
    isFiltered: true,
  }),
]

export const OaMaScenarioHeaders = [
  // intCol({ ident: 'scenarioId', display: 'Scenario Id', isKey: true }),
  strCol({
    ident: 'scenarioName',
    display: 'Scenario Name',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
  // strCol({ ident: 'unitid', display: 'Unitid', isFiltered: true }),
  // strCol({ ident: 'utility', display: 'Utility', isFiltered: true }),
  strCol({
    ident: 'unit',
    display: 'Unit',
    isFiltered: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({ ident: 'author', display: 'Author', isKey: true }),
  dateCol({
    ident: 'startdate',
    display: 'Startdate',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  dateCol({ ident: 'enddate', display: 'Enddate', isFiltered: true }),
  strCol({
    ident: 'publicPrivate',
    display: 'Public / Private',
    isFiltered: true,
  }),
  strCol({
    ident: 'comments',
    display: 'Comments',
    isFiltered: true,
    width: 750,
    ellipsis: true,
    alignment: 'left',
  }),
]

const OaTmpRptConstraintHeaders = [
  strCol({ ident: 'unitname', display: 'Unitname', isFiltered: true }),
  numCol({ ident: 'referenceNo', display: 'ReferenceNo', isFiltered: true }),
  strCol({ ident: 'explanation', display: 'Explanation', isFiltered: true }),
  strCol({ ident: 'startdate', display: 'Startdate', isFiltered: true }),
  strCol({ ident: 'starthour', display: 'Starthour', isFiltered: true }),
  strCol({ ident: 'enddate', display: 'Enddate', isFiltered: true }),
  strCol({ ident: 'endhour', display: 'Endhour', isFiltered: true }),
  numCol({ ident: 'revenue', display: 'Revenue', isFiltered: true }),
  numCol({ ident: 'startupCost', display: 'StartupCost', isFiltered: true }),
  numCol({ ident: 'noloadCost', display: 'NoloadCost', isFiltered: true }),
  numCol({ ident: 'totalIncCost', display: 'TotalIncCost', isFiltered: true }),
  numCol({ ident: 'profit', display: 'Profit', isFiltered: true }),
  numCol({
    ident: 'hottocoldTime',
    display: 'HottocoldTime',
    isFiltered: true,
  }),
  numCol({
    ident: 'hottointerTime',
    display: 'HottointerTime',
    isFiltered: true,
  }),
  numCol({ ident: 'startupTime', display: 'StartupTime', isFiltered: true }),
  numCol({ ident: 'minDowntime', display: 'MinDowntime', isFiltered: true }),
  numCol({ ident: 'minRuntime', display: 'MinRuntime', isFiltered: true }),
  numCol({ ident: 'maxRuntime', display: 'MaxRuntime', isFiltered: true }),
  numCol({
    ident: 'maxdailyStarts',
    display: 'MaxdailyStarts',
    isFiltered: true,
  }),
]

const OaTmpPnodeZone2Headers = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'fromdate', display: 'Fromdate', isFiltered: true }),
  dateCol({ ident: 'todate', display: 'Todate', isFiltered: true }),
  strCol({ ident: 'pnodeid', display: 'Pnodeid', isFiltered: true }),
  strCol({ ident: 'emktid', display: 'Emktid', isFiltered: true }),
  strCol({ ident: 'rollupEmktid', display: 'RollupEmktid', isFiltered: true }),
  strCol({ ident: 'action', display: 'Action', isFiltered: true }),
]

export const OaCostWkHeaders = [
  // strCol({ ident: 'unitid', display: 'Unitid', isFiltered: true }),
  // dateCol({
  //   ident: 'effectivedate',
  //   display: 'Effectivedate',
  //   isFiltered: true,
  // }),
  strCol({
    ident: 'effectivedateStr',
    display: 'Effectivedate',
    isFiltered: true,
  }),
  numCol({ ident: 'endMw', display: 'End MW', isFiltered: true }),
  numCol({
    ident: 'acoefficient',
    display: 'A Coefficient',
    isFiltered: true,
    displayFormat: '000,000.0000',
  }),
  numCol({
    ident: 'bcoefficient',
    display: 'B Coefficient',
    isFiltered: true,
    displayFormat: '000,000.0000',
  }),
  numCol({
    ident: 'ccoefficient',
    display: 'C Coefficient',
    isFiltered: true,
    displayFormat: '000,000.0000',
  }),
  strCol({
    ident: 'dcoefficient',
    display: 'D Coefficient',
    isFiltered: true,
    displayFormat: '000,000.0000',
  }),
  numCol({ ident: 'perfFactor', display: 'Perf Factor', isFiltered: true }),
  strCol({
    ident: 'pfuelCode',
    display: 'Primary Fuel',
    isFiltered: true,
    width: 120,
  }),
  strCol({
    ident: 'startfuelCode',
    display: 'Startup Fuel',
    isFiltered: true,
    width: 120,
  }),
  numCol({ ident: 'genCost', display: 'Gen Cost($/mbtu)', isFiltered: true }),
  // numCol({ ident: 'noloadCost', display: 'NoloadCost', isFiltered: true }),
  numCol({
    ident: 'hotstartupCost',
    display: 'Hot Startup Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'interstartupCost',
    display: 'Inter Startup Cost ($)',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldstartupCost',
    display: 'Cold Startup Cost ($)',
    isFiltered: true,
  }),
  strCol({
    ident: 'pnodeid',
    display: 'Price Node',
    isFiltered: true,
    width: 120,
  }),
  numCol({ ident: 'ecoMinmw', display: 'Eco Min MW', isFiltered: true }),
  numCol({ ident: 'ecoMaxmw', display: 'Eco Max MW', isFiltered: true }),
  intCol({
    ident: 'minRuntime',
    display: 'Min Runtime (Hr)',
    isFiltered: true,
  }),
  intCol({
    ident: 'maxRuntime',
    display: 'Max Runtime (Hr)',
    isFiltered: true,
  }),
  intCol({
    ident: 'minDowntime',
    display: 'Min Downtime (Hr)',
    isFiltered: true,
  }),
  numCol({
    ident: 'hottocoldTime',
    display: 'Hot-Cold Time (Hr)',
    isFiltered: true,
  }),
  numCol({
    ident: 'hottointer Time',
    display: 'Hot-Inter Time (Hr)',
    isFiltered: true,
  }),
  numCol({
    ident: 'coldstartupTime',
    display: 'Cold startup Time (Hr)',
    isFiltered: true,
  }),
  numCol({
    ident: 'interstartupTime',
    display: 'Inter Startup Time (Hr)',
    isFiltered: true,
  }),
  numCol({
    ident: 'hotstartupTime',
    display: 'Hot Startup Time (Hr)',
    isFiltered: true,
  }),
  intCol({
    ident: 'maxdailyStarts',
    display: 'Max Daily Starts',
    isFiltered: true,
  }),
  // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
]

export const OaRtLmpIoHeaders = [
  // dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  strCol({
    ident: 'transdateStr',
    display: 'Transdate',
    isKey: false,
    width: 150,
  }),
  strCol({ ident: 'pnodeid', display: 'Pnodeid', isKey: false, width: 150 }),
  numCol({ ident: 'hour1', display: 'Hour 1', isFiltered: true }),
  numCol({ ident: 'hour2', display: 'Hour 2', isFiltered: true }),
  numCol({ ident: 'hour3', display: 'Hour 3', isFiltered: true }),
  numCol({ ident: 'hour4', display: 'Hour 4', isFiltered: true }),
  numCol({ ident: 'hour5', display: 'Hour 5', isFiltered: true }),
  numCol({ ident: 'hour6', display: 'Hour 6', isFiltered: true }),
  numCol({ ident: 'hour7', display: 'Hour 7', isFiltered: true }),
  numCol({ ident: 'hour8', display: 'Hour 8', isFiltered: true }),
  numCol({ ident: 'hour9', display: 'Hour 9', isFiltered: true }),
  numCol({ ident: 'hour10', display: 'Hour 10', isFiltered: true }),
  numCol({ ident: 'hour11', display: 'Hour 11', isFiltered: true }),
  numCol({ ident: 'hour12', display: 'Hour 12', isFiltered: true }),
  numCol({ ident: 'hour13', display: 'Hour 13', isFiltered: true }),
  numCol({ ident: 'hour14', display: 'Hour 14', isFiltered: true }),
  numCol({ ident: 'hour15', display: 'Hour 15', isFiltered: true }),
  numCol({ ident: 'hour16', display: 'Hour 16', isFiltered: true }),
  numCol({ ident: 'hour17', display: 'Hour 17', isFiltered: true }),
  numCol({ ident: 'hour18', display: 'Hour 18', isFiltered: true }),
  numCol({ ident: 'hour19', display: 'Hour 19', isFiltered: true }),
  numCol({ ident: 'hour20', display: 'Hour 20', isFiltered: true }),
  numCol({ ident: 'hour21', display: 'Hour 21', isFiltered: true }),
  numCol({ ident: 'hour22', display: 'Hour 22', isFiltered: true }),
  numCol({ ident: 'hour23', display: 'Hour 23', isFiltered: true }),
  numCol({ ident: 'hour24', display: 'Hour 24', isFiltered: true }),
  numCol({ ident: 'hour25', display: 'Hour 25', isFiltered: true }),
  // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
]

export const toXlsxColumns = columns =>
  columns.map(col => {
    const colWidth = col.display.length * 2
    return {
      header: col.display,
      display: col.display,
      key: col.id || col.ident,
      width: (col.width && col.width / 10) || (colWidth > 10 ? colWidth : 10),
      type: col.type,
      displayFormat: col.excelFormat || col.displayFormat,
    }
  })

export const toXlsxData = (data, columnHeaders) => {
  const gridHeaders = columnToGridHeaders(columnHeaders)

  const columnMap = R.zipObj(
    gridHeaders.map(col => col.ident),
    gridHeaders
  )
  return data.map(row =>
    R.mapObjIndexed((value, key) => {
      if (key === 'row') {
        return value
      }
      const col = columnMap[key]
      if (col == null) return null
      return col.dataFormatter({ value })
    }, row)
  )
}

export const columnToGridHeaders = headers => {
  return headers.map(col => {
    const colWidth = col.display.length * 10
    const displayFormat = col.displayFormat
    return {
      display: col.display,
      ident: col.id || col.ident,
      width: col.width || (colWidth > 150 ? colWidth : 150),
      alignment: (col.align && col.align.toLowerCase()) || 'center',
      type: col.type || 'str',
      ellipsis: true,
      dataType:
        col.dataType || col.type === 'num'
          ? 'NUMBER'
          : col.type === 'date-time' || col.type === 'date'
          ? 'TIMESTAMP'
          : 'STRING',
      dataFormatter: ({ value }) => {
        if (value == null) return value

        if (
          col.dataType === 'DATE' ||
          col.dataType === 'TIMESTAMP' ||
          col.type === 'date-time'
        ) {
          return moment(value).format(displayFormat || DATE_TIME_FORMAT_UI)
        }

        if (col.dataType === 'NUMBER' || col.type === 'num') {
          return numeral(value).format(displayFormat || '#,#.##')
        }
        return value
      },
    }
  })
}

export const writeToExcel = async worksheets => {
  const workbook = getWorkbook('duke-gads')

  worksheets.forEach((ws, index) => {
    const worksheet = workbook.addWorksheet(ws.name || 'sheet' + (index + 1))
    worksheet.columns = ws.columns.map(item => ({ width: item.width }))

    const metaInfoGridHeaders = generateGridHeaderForMetaInfo(ws.metaInfo)
    const metaInfoMap = generateMetaInfoMap(ws.metaInfo)
    const metaHeaders = getHeadersFromMap(metaInfoMap)

    const metaHeadersCount = metaHeaders.length

    const metaHeaderStartRow = 1
    fillMetaData(
      worksheet,
      metaInfoGridHeaders,
      metaHeaders,
      metaHeaderStartRow
    )

    // const headerBackground = ws.headerBackgroundARGB || 'ff85edff'
    const headerBackground = ws.headerBackgroundARGB

    const headerRow = metaHeadersCount + 1
    const header = worksheet.getRow(headerRow)
    ws.columns.forEach((col, index) => {
      const cell = header.getCell(index + 1)
      // cell.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: headerBackground },
      // }
      cell.font = { bold: true }
      cell.value = col.header
    })

    const dataCount = ws.data.length
    const colorInfoMap = getColorInfoMapFromList(ws.colorInfo)
    const dataStartRow = headerRow + 1
    ws.data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(rowIndex + dataStartRow)
      ws.columns.forEach((col, index) => {
        const cell = row.getCell(index + 1)
        let value = item[col.key]
        if (col.type === 'num' && value) {
          cell.numFmt = col.displayFormat
          value = (value || '').replaceAll('$', '').replaceAll(',', '')
          value = parseFloat(value)
          cell.value = value
        } else cell.value = item[col.key]

        const color = getColorFromColorInfoMap(item.row, col.key, colorInfoMap)
        if (color != null) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: 'ff' + color,
            },
          }
        }
      })
    })

    const metaFooters = getFootersFromMap(metaInfoMap)
    const footerStartRow = dataStartRow + dataCount + 1
    fillMetaData(worksheet, metaInfoGridHeaders, metaFooters, footerStartRow)
  })

  const data = await workbook.xlsx.writeBuffer()

  var blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  return blob
}

// const getCellType = (col, value) => {
//   if (!value) return ValueType.Null
//   // if(value.includes('$'))
//   // return ValueType.Number
//   if (col.type === 'num') return ValueType.Number
//   if (col.type === 'date' || col.type === 'date-time') return ValueType.Date
//   return ValueType.String
// }

export const OaTmpMaDisplayNrgTrueupExportHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  strCol({ ident: 'displayName', display: 'Display Name', isFiltered: true }),
  dateCol({ ident: 'transdate', display: 'Date', isKey: true }),
  intCol({ ident: 'hour', display: 'Hour', isKey: true }),
  dollarCol({ ident: 'rtLmp', display: 'RT LMP', isFiltered: true }),
  numCol({ ident: 'genMw', display: 'Gen MWH', isFiltered: true }),
  dollarCol({ ident: 'daLmp', display: 'DA LMP', isFiltered: true }),
  numCol({ ident: 'daAwardMw', display: 'Da Award MWH', isFiltered: true }),
  dollarCol({
    ident: 'rtRevenue',
    display: 'RT Revenue',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'daRevenue',
    display: 'DA Revenue',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'totalGencost',
    display: 'Generation Cost',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'startcostShare',
    display: 'Start Cost Share',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'totalCost',
    display: 'Total Cost',
    isFiltered: true,
    width: 120,
  }),
  dollarCol({
    ident: 'totalCostByGenMW',
    display: 'Total Cost ($/MWH)',
    isFiltered: true,
    width: 120,
  }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  strCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
  numCol({ ident: 'targetMw', display: 'Target MW', isFiltered: true }),
  numCol({ ident: 'availMw', display: 'Avail MW', isFiltered: true }),
  numCol({ ident: 'lostMwh', display: 'Lost MWH', isFiltered: true }),
  dollarCol({
    ident: 'lostRevDollar',
    display: 'Lost Revenue',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'unavailMwCost',
    display: 'Cost Of Lost  MWH',
    isFiltered: true,
  }),
  dollarCol({
    ident: 'unavailMwCostByLost',
    display: 'Cost of Lost MWH ($/MWH)',
    isFiltered: true,
  }),
  numCol({
    ident: 'euor',
    display: 'EUOR MW',
    isFiltered: true,
  }),
  numCol({ ident: 'netdepcap', display: 'Net Dep Cap', isFiltered: true }),
  numCol({ ident: 'ecoMax', display: 'Eco Max', isFiltered: true }),
  numCol({ ident: 'ecoMin', display: 'Eco Min', isFiltered: true }),
  numCol({ ident: 'ecomaxrate', display: 'Eco max Rate', isFiltered: true }),
  numCol({ ident: 'ecominrate', display: 'Eco Min Rate', isFiltered: true }),
  numCol({
    ident: 'plantOverPerformance',
    display: 'Plant Over Performance',
    isFiltered: true,
  }),
  numCol({
    ident: 'commaOpsEventTrueup',
    display: 'CommOps Event True Up',
    isFiltered: true,
  }),
  numCol({
    ident: 'commaOpsNonEventTrueup',
    display: 'CommOps Non Event True Up',
    isFiltered: true,
  }),
  numCol({
    ident: 'commaOpsDAOppotunityLoss',
    display: 'CommOps DA Opportunity Loss',
    isFiltered: true,
  }),
  numCol({
    ident: 'trueupAdj',
    display: 'True Up Adjustment',
    isFiltered: true,
  }),
  numCol({
    ident: 'trueUp',
    display: 'Total CommOps True Up',
    isFiltered: true,
  }),
  numCol({
    ident: 'rsMbLofOpportunity',
    display: 'RS_MB_LOF Opportunity Loss',
    isFiltered: true,
  }),
  strCol({ ident: 'explanation', display: 'Explanation', isFiltered: true }),
]

export const oaEventTrueUpExportHeadersNRG = [
  intCol({ ident: 'eventnum', display: 'Event #', isFiltered: true }),
  strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    isFiltered: true,
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    isFiltered: true,
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  numCol({ ident: 'availcap', display: 'Avail MW', isFiltered: true }),
  numCol({
    ident: 'euorAdjMW',
    display: 'EUOR Adj MW',
    isFiltered: true,
  }),
  numCol({ ident: 'lostOppMwh', display: 'Lost MWH', isFiltered: true }),
  numCol({ ident: 'lostEhrs', display: 'Lost Eqv Hrs', isFiltered: true }),
  numCol({ ident: 'avgEcoMin', display: 'Eco Min Rate', isFiltered: true }),
  numCol({
    ident: 'wtvGenCost',
    display: 'Wt. Avg. Gen Cost',
    isFiltered: true,
  }),
  dollarCol({ ident: 'avgDALmp', display: 'DA LMP', isFiltered: true }),
  dollarCol({ ident: 'avgRTLmp', display: 'RT LMP', isFiltered: true }),
  numCol({
    ident: 'avgLmp',
    display: 'Wt. Avg. LMP',
    isFiltered: true,
  }),
  numCol({
    ident: 'trueUp',
    display: 'CommOps True Up',
    isFiltered: true,
  }),
  numCol({
    ident: 'trueUpInc',
    display: 'True Up',
    isFiltered: true,
  }),
  strCol({
    ident: 'fuelType',
    display: 'Fuel Type',
    isFiltered: true,
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isFiltered: true,
    displayFormat: '0',
  }),
  strCol({
    ident: 'causeDescrip',
    display: 'Cause Description',
    isFiltered: true,
    width: 400,
    ellipsis: true,
    alignment: 'left',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isFiltered: true,
    ellipsis: true,
    alignment: 'left',
    width: 600,
  }),
]
